import { Box, Grid, styled, Typography } from "~/common/mui";
import classNames from "classnames";
import { CMSImageTileView, type CMSImageTileViewProps } from "~/features/cms/components/cmsImageTile/CMSImageTile";

export const CMS_IMAGE_TILE_CONTENT_TYPE = "ImageTileContentComponent" as const;

export type ImageTileContentItemDTO = CMSImageTileViewProps;

export interface CMSImageTileContentProps {
  type: typeof CMS_IMAGE_TILE_CONTENT_TYPE;
  id: string;
  className?: string;
  headerText?: string;
  subHeaderText?: string;
  imageTiles?: ImageTileContentItemDTO[];
}

export const CMSImageTileContent = ({ headerText, subHeaderText, imageTiles, className }: CMSImageTileContentProps) => {
  const tiles = imageTiles ?? [];

  if (!headerText && !subHeaderText && tiles.length === 0) {
    return null;
  }

  return (
    <Root className={classNames("scha__cms", "scha__cms-image-tile-content", className)}>
      {headerText ? (
        <Typography variant="headlineLarge" component="h2">
          {headerText}
        </Typography>
      ) : null}
      {subHeaderText ? (
        <Typography variant="titleMedium" component="h3" sx={{ fontWeight: "bold" }}>
          {subHeaderText}
        </Typography>
      ) : null}

      {tiles.length > 0 ? (
        <TileGrid container spacing={{ phone: 1.5, "desktop-s": 3 }}>
          {tiles.map((tile, index) => (
            <Grid key={index} size={{ phone: 6, "desktop-s": "grow" }}>
              <CMSImageTileView {...tile} />
            </Grid>
          ))}
        </TileGrid>
      ) : null}
    </Root>
  );
};

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

const TileGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  "&:first-of-type": {
    marginTop: 0,
  },
}));
